// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"71a6b55b","231":"5cebb263","293":"56dfdd78","301":"8ba2b2d2","379":"d3447aa2","642":"343325f2","810":"4515d329","938":"bb276651"}[chunkId] + ".chunk.js";
};